/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type fetchTradeOnApprovalEligibilityQueryVariables = {
    userId: string;
    itemId: string;
};
export type fetchTradeOnApprovalEligibilityQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly displayInfo: {
                readonly ctas: {
                    readonly showRequestOnApproval: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type fetchTradeOnApprovalEligibilityQuery = {
    readonly response: fetchTradeOnApprovalEligibilityQueryResponse;
    readonly variables: fetchTradeOnApprovalEligibilityQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  },
  {
    "kind": "Literal",
    "name": "pageType",
    "value": "PDP"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayInfo",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userId"
    }
  ],
  "concreteType": "ItemDisplayInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ctas",
      "storageKey": null,
      "args": null,
      "concreteType": "CTADisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestOnApproval",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "fetchTradeOnApprovalEligibilityQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "fetchTradeOnApprovalEligibilityQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "fetchTradeOnApprovalEligibilityQuery",
    "id": "app-buyer-finding/237.0.0-2019-10-18T13:55:49.909Z/fetchTradeOnApprovalEligibilityQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '8e58062f33a319a85a563f132b183fe4';
export default node;
